<template>
    <div class="CertificateTemplate">
        <div class="imgList">
            <img :src="`${baseUrl}img/Certificate/${img1}.jpg`" alt="" srcset="">
            <img :src="`${baseUrl}img/Certificate/${img1}.jpg`" alt="" srcset="">  
        </div>
        <div class="title">
            {{title}}
        </div>
        <div v-for="(item, index) in data" :key="index">
            <div class="DataTitle">
                <div class="cricle"></div>
                {{item.title}}
            </div>
            <div v-if="item.text" class="text">
                {{item.text}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
        }
    },
    props:[
        'img1','img2','title','data'
    ]
}
</script>
<style lang="less">
.CertificateTemplate{
    width: 100%;
    margin-bottom: 3rem;
    
    .imgList{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img{
            width: 49%;
        }
    }
    .title{
        color: #017CA8;
        margin: 1rem 0;
        font-weight: bold;
        font-size: 0.9rem;
    }
    .DataTitle{
        display: flex;
        align-items: center;
        font-size: 0.7rem;
        margin-top: 1rem;
        color: #4C4C4C;
        .cricle{
            width: 10px;
            background-color: #017CA8;
            height: 10px;
            border-radius: 50%;
            margin-right: 20px;
        }
        
    }
    .text{
        font-size: 0.7rem;
        color: #4C4C4C;
        margin-left: 30px;
    }
}
</style>

